import { motion, AnimatePresence } from "framer-motion"
import { useEffect, useState } from "react"
import { Star, TrendingUp, Search } from "lucide-react"

const listings = [
  {
    title: "SoHo Loft",
    location: "New York, USA",
    rank: "#3",
    visibility: "+48%",
    clicks: "+32%",
    reviews: "4.9",
    keywords: "Luxury · Central · Modern",
    image:
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=1600",
  },
  {
    title: "Downtown Suite",
    location: "Toronto, Canada",
    rank: "#5",
    visibility: "+36%",
    clicks: "+24%",
    reviews: "4.8",
    keywords: "City · Cozy · Business",
    image:
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=1600",
  },
]

export default function FeatureVisualListings() {

  const [index, setIndex] = useState(0)

  useEffect(() => {
    const i = setInterval(() => {
      setIndex(i => (i + 1) % listings.length)
    }, 4000)
    return () => clearInterval(i)
  }, [])

  const current = listings[index]

  return (
    <div className="w-full h-full relative overflow-hidden rounded-xl">

      {/* 🔥 IMAGE */}
      <AnimatePresence mode="wait">
        <motion.img
          key={index}
          src={current.image}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </AnimatePresence>

      {/* 🔥 STRONGER OVERLAY FOR CONTRAST */}
      <div className="absolute inset-0 bg-black/60" />

      {/* 🔥 CONTENT */}
      <div className="relative z-10 h-full flex flex-col justify-between p-6 text-white">

        {/* 🔝 HEADER */}
        <div className="flex justify-between items-start">

          <div>
            <p className="text-small font-semibold text-white">
              {current.title}
            </p>
            <p className="text-micro text-white">
              {current.location}
            </p>
          </div>

          <span className="text-micro text-white">
            Optimised listing
          </span>

        </div>

        {/* 🔥 CENTER SEO PERFORMANCE */}
        <AnimatePresence mode="wait">
          <motion.div
            key={current.rank}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >

            <div className="flex justify-center items-center gap-2 text-small text-white">
              <Search size={14} />
              Ranking improved
            </div>

            <div className="text-[42px] font-bold text-white">
              {current.rank}
            </div>

            <div className="text-small flex justify-center items-center gap-1 text-white">
              <TrendingUp size={14} />
              {current.visibility} visibility
            </div>

          </motion.div>
        </AnimatePresence>

        {/* 🔽 BOTTOM PANEL (NO GLASS FADE LOOK) */}
        <div className="
          bg-black/40
          border border-white/20
          rounded-xl
          p-4
          flex flex-col gap-3
        ">

          {/* METRICS */}
          <div className="grid grid-cols-3 gap-3 text-small">

            <div>
              <p className="text-white">Clicks</p>
              <p className="font-semibold text-white">
                {current.clicks}
              </p>
            </div>

            <div>
              <p className="text-white">Rating</p>
              <p className="flex items-center gap-1 font-semibold text-white">
                <Star size={12} />
                {current.reviews}
              </p>
            </div>

            <div>
              <p className="text-white">Status</p>
              <p className="font-semibold text-white">
                Ranking ↑
              </p>
            </div>

          </div>

          {/* KEYWORDS */}
          <div className="text-micro text-white">
            Keywords: {current.keywords}
          </div>

        </div>

      </div>
    </div>
  )
}